export enum EntityTypes {
  ACCOUNT = 'ACCOUNT',
  PROJECT = 'PROJECT',
  USER = 'USER',
}
